<h1 mat-dialog-title *ngIf="scope.title">{{ scope.title }}</h1>
<div mat-dialog-content>
  <div class="row" *ngIf="scope.icon">
    <div class="col-md-12 text-center">
      <gs-icon [type]="scope.icon"></gs-icon>
      <div *ngIf="scope.confirmMessage" class="confirm">
        {{ scope.confirmMessage }}
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 body">
      <div>{{ scope.body }}</div>
      <small class="caption" *ngIf="scope.caption">{{ scope.caption }}</small>
    </div>
  </div>
</div>
<div mat-dialog-actions class="mt-10">
  <div class="button-set" [ngClass]='{"text-center" : isCenter}'>
    <button
      *ngFor="let button of scope.buttons"
      mat-stroked-button
      type="{{button.buttonType}}"
      [mat-dialog-close]="button.bool"
      tabindex="-1"
    >
      {{ button.title }}
    </button>
  </div>
</div>
